import React from 'react';
import get from 'lodash/get';
import {Table} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

const WinnerContact = props => {
  const fulfillmentInfo = get(props.winner, 'fulfillmentInfo', {});
  const {address1, address2, city, state, zip, email, phone} = fulfillmentInfo;
  const address = [address1, address2, [city, state].join(', '), zip].join('\n');

  return (
    <Table>
      <Table.Header className='white-header'>
        <Table.HeaderCell>
          <FormattedMessage id='modal.winnerDetail.label.address' />
        </Table.HeaderCell>
        <Table.HeaderCell>
          <FormattedMessage id='modal.winnerDetail.label.email' />
        </Table.HeaderCell>
        <Table.HeaderCell>
          <FormattedMessage id='modal.winnerDetail.label.phone' />
        </Table.HeaderCell>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell className='winner-contact-address'>{address}</Table.Cell>
          <Table.Cell>{email}</Table.Cell>
          <Table.Cell>{phone}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export default WinnerContact;



// WEBPACK FOOTER //
// ./public/components/WinnerDetailModal/WinnerContact.jsx